import React from "react";
import * as PR from "../prime-react/index";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

const MenuBar = () => {
    const navigate = useNavigate();
    const pathname = window.location.pathname;
    const navigatePath = (selectedPath) => {
        pathname !== selectedPath && navigate(selectedPath)
    }
    const role = useSelector(state => state.auth.role);
    const store = useSelector((state) => state.filterOptions);


    const allItems = [
        {
            id: 'home',
            label: 'Home',
            className: (pathname === '/home') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/home'),
            isVisible: true
        },
        {
            id: 'alerts',
            label: 'Alerts',
            className: (pathname === '/alerts') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/alerts'),
            isVisible: true
        },
        {
            id: 'analytics',
            label: 'My Analytics',
            className: (pathname === '/my-analytics') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/my-analytics'),
            isVisible: (role === 'member' || role === 'managedmember') ? true : false
        },
        {
            id: 'caseupdates',
            label: 'Case Updates',
            className: (pathname === '/case-updates') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/case-updates'),
            isVisible: (role === 'member' || role === 'managedmember') ? true : false
        },
        {
            id: 'reports',
            label: 'Reports',
            className: (pathname === '/reports') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/reports'),
            isVisible: role === 'regulator' || role === 'governingbody' ? true : false
        },
        {
            id: 'news',
            label: 'News',
            className: (pathname === '/news') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/news'),
            isVisible: true
        },
        {
            id: 'externallinks',
            label: 'External Links',
            className: (pathname === '/external-links') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/external-links'),
            isVisible: true
        },
        {
            id: 'conversations',
            label: 'Conversations',
            className: (pathname === '/conversations') ? 'p-menuitem-active' : '',
            command: () => navigatePath('/conversations'),
            isVisible: (role === 'regulator' || role === 'governingbody'),
            template: (item, options) => (
                <span className={`flex align-items-center ${options.className}`} onClick={options.onClick}>
                    <span>{item.label}</span>
                    {store.messageCount !== 0 && <span className="ml-2 badge">{store.messageCount}</span>}
                </span>
            )
        },
    ];

    const items = allItems.filter(item => item.isVisible);

    return (
        <>
            {role !== 'analyst' && <div className={`menu-section ${role === 'regulator'
                    ? 'regulator-menu'
                    : role === 'member'
                        ? 'member-menu'
                        : role === 'analyst'
                            ? 'analyst-menu'
                            : role === 'managedmember'
                                ? 'member-menu'
                                : role === 'governingbody'
                                    ? 'regulator-menu'
                                    : ''
                }`}>
                <PR.Menubar model={items} />
            </div>
            }
        </>
    );
};

export default MenuBar;